import { useEffect, useState } from 'react'
import { useScript } from 'hooks/script'
import { useEnvironment } from 'contexts/environment'
import { useI18n } from 'contexts/i18n'
import { useAccess } from 'contexts/access'
import { useAccount } from 'contexts/account'
import { useMe } from 'contexts/me'
import { useOrganization } from 'contexts/organization'
import { getFullName, getEmailAddress } from 'utilities/person'
import { capitalize } from 'utilities/string'

const Pendo = () => {
    const { integrations } = useEnvironment()
    const { locale } = useI18n()

    const {
        initialized: accessInitialized,
        permissions,
        currentPlan
    } = useAccess()

    const { account } = useAccount()
    const { me } = useMe()
    const { organization } = useOrganization()

    const [loaded, setLoaded] = useState(false)
    const [initialized, setInitialized] = useState(false)

    useScript({
        id: 'pendo',
        src: `//cdn.eu.pendo.io/agent/static/${integrations?.pendoApiKey}/pendo.js`,
        onLoad: ({ first = false }) => first && setLoaded(true),
        dependencies: [!!integrations?.pendoEnabled, !!integrations?.pendoApiKey]
    })

    useEffect(() => {
        if(!loaded || initialized) {
            return
        }

        if(!locale || !accessInitialized || !currentPlan || !account || !me || !organization) {
            return
        }

        setInitialized(true)

        global.pendo.initialize({
            visitor: {
                id: me.id,
                name: getFullName(me),
                email: getEmailAddress(me),
                userPermissions: permissions,
                locale
            },
            account: {
                id: organization.id,
                accountName: organization.name,
                ...(!!account.address.country ? {
                    accountCountry: getCountryName.of(account.address.country)
                } : null),
                payingStatus: !currentPlan.free && !currentPlan.inTrial,
                businessTier: capitalize(currentPlan.bundle),
            }
        })
    }, [loaded, initialized, locale, accessInitialized, currentPlan, account, me, organization])

    return null
}

const getCountryName = new Intl.DisplayNames(['en'], { type: 'region' })

export default Pendo